module.exports = __webpack_public_path__ + "images/play-btn-b275f4d45582b6cd9567aaad47dd1f18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Logos/play-btn.svg
// module id = 27
// module chunks = 0